import { render, staticRenderFns } from "./gameResultCockfightExportFull.vue?vue&type=template&id=42eb4f82&lang=pug"
import script from "./gameResultCockfightExportFull.vue?vue&type=script&lang=js"
export * from "./gameResultCockfightExportFull.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports